import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@orijinworks/frontend-commons';

const ConfirmationDialog = ({
                              open,
                              onClose,
                              onConfirm,
                              title,
                              message,
                              confirmText = 'Confirm',
                              cancelText = 'Cancel',
                              confirmColor = 'secondary',
                              classes = {},
                              testIds = {}
                            }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <strong>{title}</strong>
        <IconButton
          size="small"
          onClick={onClose}
          data-testid={testIds.closeButton || 'dialog-close-button'}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>
    <DialogContent>
      <Typography>{message}</Typography>
    </DialogContent>
    <DialogActions className={classes.dialogActions}>
      <Button
        variant="contained"
        color={confirmColor}
        onClick={onConfirm}
        data-testid={testIds.confirmButton || 'confirm-button'}
      >
        {confirmText}
      </Button>
      <Button
        variant="outlined"
        onClick={onClose}
        data-testid={testIds.cancelButton || 'cancel-button'}
      >
        {cancelText}
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmColor: PropTypes.string,
  classes: PropTypes.object,
  testIds: PropTypes.object
};

export default ConfirmationDialog;
